import React, { useEffect, useState, FC } from 'react'
import dayjs from 'dayjs';
import 'dayjs/locale/th';          // โหลด locale ไทย

interface JackpotProps {
    data: number;
}

const JackpotWidget: FC<JackpotProps> = ({ data }) => {
    const todayDate = dayjs().format('YYYY-MM-DD');
    const todayTimestamp = dayjs(todayDate).valueOf();
    const timestampSeed = todayTimestamp % 500000;
    const initialJackpot = data + timestampSeed;

    const [jackpot, setJackpot] = useState(initialJackpot);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            const increase = Math.floor(Math.random() * 201) + 300; // +300-500
            setJackpot((prev) => prev + increase);
        }, 2_000);

        return () => clearInterval(timer);
    }, []);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    return (
        <>
            <div className="jackpot-banner-container" style={{ opacity: imageLoaded ? 1 : 0, transition: 'opacity 0.3s ease-in-out' }}>
                <a className="jackpot-banner-link" href="/home">
                    <div>
                        <div className="jackpot-image-wrapper">
                            <img
                                loading="lazy"
                                alt="jackpots"
                                className="jackpot-image"
                                src="/widget/jackpots.gif"
                                onLoad={handleImageLoad}
                            />
                        </div>
                    </div>
                    <div className="jackpot-text-overlay">
                        <span>{jackpot.toLocaleString('th-TH')}</span>
                    </div>
                </a>
            </div>
        </>
    )
}

export default JackpotWidget
